import { NgControl } from "@angular/forms";
import { AfterViewInit, Directive, Input } from "@angular/core";

@Directive({
    selector: "[disableControl]",
    standalone: false
})
export class DisableControlDirective implements AfterViewInit {
  private _condition: boolean;

  @Input() set disableControl(condition: boolean) {
    this._condition = condition;
    this.toggleControlAsync();
  }

  constructor(private ngControl: NgControl) {}

  ngAfterViewInit() {
    this.toggleControlAsync();
  }

  private toggleControlAsync() {
    Promise.resolve().then(() => {
      this.toggleControl();
    });
  }

  private toggleControl() {
    if (this.ngControl && this.ngControl.control) {
      const action = this._condition ? "disable" : "enable";
      this.ngControl.control[action]({ emitEvent: false });
    }
  }
}
